const salarioMinimo = [];

salarioMinimo["2005"] = [
  300,
  300,
  300,
  300,
  300,
  300,
  300,
  300,
  300,
  300,
  300,
  300
];

salarioMinimo["2006"] = [
  350,
  350,
  350,
  350,
  350,
  350,
  350,
  350,
  350,
  350,
  350,
  350
];

salarioMinimo["2007"] = [
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380,
  380
];

salarioMinimo["2008"] = [
  415,
  415,
  415,
  415,
  415,
  415,
  415,
  415,
  415,
  415,
  415,
  415
];

salarioMinimo["2009"] = [
  465,
  465,
  465,
  465,
  465,
  465,
  465,
  465,
  465,
  465,
  465,
  465
];

salarioMinimo["2010"] = [
  510,
  510,
  510,
  510,
  510,
  510,
  510,
  510,
  510,
  510,
  510,
  510
];

salarioMinimo["2011"] = [
  545,
  545,
  545,
  545,
  545,
  545,
  545,
  545,
  545,
  545,
  545,
  545
];

salarioMinimo["2012"] = [
  622,
  622,
  622,
  622,
  622,
  622,
  622,
  622,
  622,
  622,
  622,
  622
];

salarioMinimo["2013"] = [
  678,
  678,
  678,
  678,
  678,
  678,
  678,
  678,
  678,
  678,
  678,
  638
];

salarioMinimo["2014"] = [
  724,
  724,
  724,
  724,
  724,
  724,
  724,
  724,
  724,
  724,
  724,
  724
];

salarioMinimo["2015"] = [
  788,
  788,
  788,
  788,
  788,
  788,
  788,
  788,
  788,
  788,
  788,
  788
];

salarioMinimo["2016"] = [
  880,
  880,
  880,
  880,
  880,
  880,
  880,
  880,
  880,
  880,
  880,
  880
];

salarioMinimo["2017"] = [
  937,
  937,
  937,
  937,
  937,
  937,
  937,
  937,
  937,
  937,
  937,
  937
];

salarioMinimo["2018"] = [
  954,
  954,
  954,
  954,
  954,
  954,
  954,
  954,
  954,
  954,
  954,
  954
];

salarioMinimo["2019"] = [
  998,
  998,
  998,
  998,
  998,
  998,
  998,
  998,
  998,
  998,
  998,
  998
];

salarioMinimo["2020"] = [
  1039,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045,
  1045
];

salarioMinimo["2021"] = [
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100,
  1100
];

salarioMinimo["2022"] = [
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212,
 1212
];

salarioMinimo["2023"] = [
 1302,
 1302,
 1302,
 1302,
 1320,
 1320,
 1320,
 1320,
 1320,
 1320,
 1320,
 1320
];

salarioMinimo["2024"] = [
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412,
 1412
];

salarioMinimo["2025"] = [
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518,
  1518
 ];

export default salarioMinimo;




// WEBPACK FOOTER //
// ./src/config/salarioMinimo.js